var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReplace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.858 6.85547H9.94369C9.60084 6.85547 9.25798 7.0269 9.00084 7.28404C8.74369 7.54118 8.57227 7.88404 8.57227 8.2269V19.1983C8.57227 19.5412 8.74369 19.884 9.00084 20.1412C9.25798 20.3983 9.60084 20.5698 9.94369 20.5698H18.3437C18.6866 20.5698 19.0294 20.3983 19.2866 20.1412C19.5437 19.884 19.7151 19.5412 19.7151 19.1983V10.7126L15.858 6.85547Z",
    fill: "white",
    stroke: "#505F79",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0566 16.2846H5.65659C5.31373 16.2846 4.97087 16.1132 4.71373 15.856C4.45658 15.5989 4.28516 15.256 4.28516 14.9132V3.94174C4.28516 3.59888 4.45658 3.25603 4.71373 2.99888C4.97087 2.74174 5.31373 2.57031 5.65659 2.57031H11.5709L14.5709 5.57031",
    stroke: "#505F79",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4277 7.71484V12.0006H19.7134",
    stroke: "#505F79",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2871 18.4302L15.43 16.2874L13.2871 14.1445",
    stroke: "#505F79",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7148 16.2891L7.71484 16.2891",
    stroke: "#505F79",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReplace);
export default __webpack_public_path__ + "static/media/replace.08a0f9b6a785add7053043466d49136f.svg";
export { ForwardRef as ReactComponent };